function inferApiBaseUrl() {
    if (typeof window !== 'undefined' && window.location.hostname.endsWith('easyfastv.space')) {
        return 'https://api.easyfastv.space/api/';
    }
    return 'https://api.efv.me/api/';
}

const server = process.env.REACT_APP_API_BASE_URL || inferApiBaseUrl()
let token = window.Telegram?.WebApp?.initData || ''
const telegram_user = window.Telegram?.WebApp?.initDataUnsafe?.user
let telegram_id = telegram_user?.id ? telegram_user.id : 480642114
let telegram_login = telegram_user?.username || ''
let telegram_name = [telegram_user?.first_name, telegram_user?.last_name].filter(Boolean).join(' ')
let telegram_avatar = telegram_user?.photo_url || ''

export async function startClientAPI(){
    try{
        let data = {
            telegram_id: telegram_id,
            telegram_login: telegram_login,
            telegram_name: telegram_name,
            telegram_avatar: telegram_avatar
        }
        let response = await fetch(server + 'start_client',{
            method:'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        });
        await response.json()
    }catch (error) {
        console.error(error);
    }
}

export async function getClientAPI(){
    try{
        let response = await fetch(server + 'get_client?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        return (await response.json()).res
    }catch (error) {
        console.error(error);
        return []
    }
}


export async function getServersListAPI(){
    try{
        let response = await fetch(server + 'get_list_configs?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        let res = await response.json()
        if(res.status === 'OK')
            return res.res
        else
            return []
    }catch (error) {
        console.error(error);
        return []
    }
}

export async function getServersAPI(){
    try{
        let response = await fetch(server + 'get_servers',{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        const res = await response.json()
        let resAmneziaWG = []
        let resWireguard = []
        res.res.forEach(item=>{
            if(item.client === 'AmneziaWG')
                resAmneziaWG.push(item)
            else if(item.client === 'Wireguard')
                resWireguard.push(item)
            // VLESS servers are not create choices — subscription-only UX
        })
        const toOptions = (rows) => {
            const seen = new Set()
            const out = []
            rows.forEach((s) => {
                const key = `${s.country}__${s.client}__${s.is_premium ? 1 : 0}`
                if (seen.has(key)) return
                seen.add(key)
                out.push({
                    name: s.country,
                    client: s.client,
                    is_premium: Boolean(s.is_premium),
                })
            })
            out.sort((a, b) => {
                if (a.is_premium === b.is_premium) return 0
                return a.is_premium ? -1 : 1
            })
            return out.map((x, idx) => ({...x, id: idx + 1}))
        }

        // [0]=AmneziaWG, [1]=Wireguard (VLESS removed from country picker)
        return [
            toOptions(resAmneziaWG),
            toOptions(resWireguard),
        ]
    }catch (error) {
        console.error(error);
        return []
    }
}

export async function newConfigAPI(country){
    try{
        let data = {
            telegram_id: telegram_id,
            country: country.name,
            platform: country.client,
        }
        let response = await fetch(server+'create_config',{
            method:'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        });
        await response.json()
    }catch (error) {
        console.error(error);
    }
}

export async function newPremiumConfigAPI(country){
    try{
        let data = {
            telegram_id: telegram_id,
            country: country.name,
            platform: country.client,
            confirmed: true,
        }
        let response = await fetch(server+'create_premium_config',{
            method:'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        });
        await response.json()
    }catch (error) {
        console.error(error);
    }
}

export async function getVpnSubscriptionAPI(){
    try{
        let response = await fetch(server+'vpn_subscription?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        const res = await response.json()
        if(res.status === 'OK')
            return res.res
        return { exists: false, url: null, locations: [] }
    }catch (error) {
        console.error(error);
        return { exists: false, url: null, locations: [] }
    }
}

export async function ensureVpnSubscriptionAPI(){
    try{
        let data = { telegram_id: telegram_id }
        let response = await fetch(server+'vpn_subscription/ensure',{
            method:'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        });
        const res = await response.json()
        if(res.status === 'OK')
            return res.res
        throw new Error(res.message || 'Не удалось получить подписку')
    }catch (error) {
        console.error(error);
        throw error
    }
}

export async function getConfigAPI(config){
    try{
        let response = await fetch(server+'get_config?telegram_id='+telegram_id+'&config='+config,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        await response.json()
    }catch (error) {
        console.error(error);
    }
}

export async function deleteConfigAPI(deleteConfigOpen){
    try{
        let data = {
            telegram_id: telegram_id,
            config: deleteConfigOpen.name,
        }
        let response = await fetch(server+'delete_config',{
            method:'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        });
        await response.json()
    }catch (error) {
        console.error(error);
    }
}

export async function getPaymentLink(amount, is_month){
    let link = server+'create_payment_link?telegram_id='+telegram_id
    if(is_month)
        link += '&is_month=yes'
    else
        link += '&amount='+amount
    try{
        let response = await fetch(link,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        const json = await response.json()
        if (json.status !== 'OK') {
            console.error(json.message || json)
            return null
        }
        return json.res
    }catch (error) {
        console.error(error);
    }
}

export async function deletePaymentAPI(){
    try{
        let response = await fetch(server+'delete_payment_month?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        await response.json()
    }catch (error) {
        console.error(error);
    }
}


export async function getHistoryAPI(){
    try{
        let response = await fetch(server+'get_history_payment?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return (await response.json())['res']
    }catch (error) {
        console.error(error);
    }
}

export async function sendMoneyRefAPI(){
    try{
        let response = await fetch(server+'money_from_ref_balance?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return (await response.json())['res']
    }catch (error) {
        console.error(error);
    }
}

export async function getReferralsAPI(){
    try{
        let response = await fetch(server+'get_referrals?telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return (await response.json())['res']
    }catch (error) {
        console.error(error);
    }
}


export async function getChallengeReferralsAPI(){
    try{
        let response = await fetch(server+'get_challenge_refs?date_start=2025-09-01&telegram_id='+telegram_id,{
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return (await response.json())['res']
    }catch (error) {
        console.error(error);
    }
}

